import { PublicButton } from '@yes.technology/react-toolkit'
import { getPublicButtonRest, isPublicButton } from 'shared/utils'
import { CustomLinkButton } from './HeroBanner.styles'
import { HeroBannerButtonItem } from './HeroBanner.types'

export type HeroBannerButtonProps = {
  button: HeroBannerButtonItem
}

const HeroBannerButton = ({ button }: HeroBannerButtonProps) => {
  if (isPublicButton(button)) {
    return (
      <PublicButton
        href={button?.link?.url ?? button?.href ?? '#'}
        target={button?.link?.target ?? button?.target ?? '_self'}
        {...getPublicButtonRest(button)}
        style={button.style}
        disabled={button?.disabled}
      >
        {button?.label ?? ''}
      </PublicButton>
    )
  }

  return (
    <CustomLinkButton
      href={button?.href ?? '#'}
      variant='secondary'
      heightClass='large'
      rel='noopener noreferrer'
      style={button?.style}
      target={button?.target ?? '_self'}
      disabled={button?.disabled}
    >
      {button?.label ?? ''}
    </CustomLinkButton>
  )
}

export default HeroBannerButton
